import React, { Component } from 'react';
import _ from "lodash";
import { uuid } from "core/utils";

class GridMultilineCellTemplate extends Component {
    constructor(props) {
        super();

        this.props = props;
    }

    render() {
        return (
            <td className="table--multiline">
                <div className="type--left">
                    {_.map(this.props.dataItem[this.props.field], (i) => {
                        const separatorIndex = i.indexOf(":");
                        const property = separatorIndex === -1 ? i : i.slice(0, separatorIndex);
                        const values = separatorIndex === -1 ? undefined : i.slice(separatorIndex + 1);
                        return (
                            values !== '' && values !== undefined ? 
                            ( <div className="u-mar--bottom--tny" key={uuid()}><b>{property}</b>: {values}</div> ) : 
                            ( <div className="u-mar--bottom--tny" key={uuid()}>{property}</div> )
                        )
                    })}
                </div>
            </td>
        );
    }
}

export default GridMultilineCellTemplate;
